import { X } from "lucide-react";
import { Button } from "~/atoms/button";
import { ControlledCombobox } from "~/molecules/ControlledCombobox";
import { useText } from "../text";
import { type AnnualWheelEntry } from "../types";

interface Props {
  entries: AnnualWheelEntry[];
  selectedEntry?: AnnualWheelEntry;
  onSelect: (entry?: AnnualWheelEntry) => void;
}

// Picks the one document to follow, which the timeline then shows over the years
export const DocumentHistoryPicker = ({
  entries,
  selectedEntry,
  onSelect,
}: Props) => {
  const text = useText();

  return (
    <div className="flex w-80 max-w-full items-center gap-1">
      <ControlledCombobox
        value={selectedEntry ? String(selectedEntry.id) : null}
        placeholder={text.findDocument}
        options={entries.map(({ id, name }) => ({
          value: String(id),
          label: name,
        }))}
        onChange={(value) =>
          onSelect(entries.find(({ id }) => String(id) === value))
        }
      />
      {selectedEntry && (
        <Button
          variant="ghost"
          size="icon"
          aria-label={text.showAllDocuments}
          onClick={() => onSelect(undefined)}
        >
          <X />
        </Button>
      )}
    </div>
  );
};
